<!-- 游戏任务奖品配置 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="奖品名称：">
        <el-input placeholder="请输入奖品名称" @change="getTableList()" v-model="params.prizeName"></el-input>
      </el-form-item>
      <el-form-item label="券模板ID：">
        <el-input placeholder="请输入券模板ID" @change="getTableList()" v-model="params.prizeTemplateId"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
        <el-button size="small" type="primary" @click="getProductList();resetForm();title='新增';dialogVisible=true">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <el-table-column label="奖品名称" prop="prizeName"></el-table-column>
      <el-table-column label="数值" prop="prizeValue"></el-table-column>
      <el-table-column label="券模板ID" prop="prizeTemplateId"></el-table-column>
      <el-table-column label="已发放数量" prop="usedStock">
        <template slot-scope="scope">
          {{scope.row.usedStock?scope.row.usedStock:'--'}}
        </template>
      </el-table-column>
      <el-table-column label="奖品剩余数量" prop="prizeStock"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="update(scope.row)">编辑</el-button>
          <el-button 
            type="text" 
            size="small" 
            v-if="scope.row.prizeType == 1"
            @click="openInventory(scope.row)">同步库存</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="openWarning(scope.row)">库存预警</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small 
        layout="total,prev,pager,next,sizes,jumper"
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 新增/编辑 -->
    <el-dialog :title="title" width="500px" top="20px" :visible.sync="dialogVisible"> 
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item label="商品名称：" prop="productId">
          <el-select style="width: 100%" v-model="form.productId" placeholder="请选择商品" filterable clearable>
            <el-option v-for="i in productList" :key="i.productId" :value="i.productId" :label="i.productName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="券模板ID：" prop="prizeTemplateId">
          <el-input type="text" v-model="form.prizeTemplateId" placeholder="请输入券模板ID"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();dialogVisible=false;title='';">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 库存预警 -->
    <el-dialog :title="warning.title" top="20px" :visible.sync="warning.visible"> 
      <el-form :model="form" ref="warningForm" :rules="warningRules" label-width="auto">
        <el-form-item label="预警商品：">{{ warningProductName }}</el-form-item>
        <el-form-item label="预警门槛：" prop="stockWarn">
          <el-input type="text" v-model="form.stockWarn" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="预警手机号：" prop="warnMobile">
          <el-input type="text" v-model="form.warnMobile" placeholder="请输入预警手机号用 ,分割"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();warning.title='';warning.visible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmWarning()">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 同步库存 -->
    <el-dialog title="同步库存" top="20px" :visible.sync="visibleInventory"> 
      <el-form label-width="auto">
        <el-form-item label="商品名称：">{{ warningProductName }}</el-form-item>
        <el-form-item label="剩余库存：">{{ inventoryNum }}</el-form-item>
      </el-form>
      <el-table 
        :data="inventoryData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}">
        <el-table-column label="序号" prop="stockId"></el-table-column>
        <el-table-column label="cdKey" prop="cdkeyCode"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
        <el-pagination  
          :page-size="inventoryParams.pageSize"
          :total="inventoryTotal" 
          :current-page.sync="inventoryParams.pageNum" 
          :page-sizes="[10 ,20 , 30, 40, 50]"
          @size-change="handleSizeChangeInventory" 
          @current-change="handleCurrentChangeInventory">
        </el-pagination>
      </el-row>
      <el-row class="text-center mt-20">
        <el-button type="primary" @click="visibleInventory=false;withdrawVisible=true;">库存提取</el-button>
        <el-button type="primary" @click="visibleInventory=false;dialogVisibleBatch=true;formBatch.file=''">库存同步</el-button>
      </el-row>
    </el-dialog>

    <!-- 提取 -->
    <el-dialog title="提取" top="20px" width="400px" :visible.sync="withdrawVisible"> 
      <el-form :model="withdrawForm" ref="withdrawForm" :rules="withdrawRules" label-width="auto">
        <el-form-item label="提取数量：" prop="extractNum">
          <el-input type="text" v-model="withdrawForm.extractNum" placeholder="请输入提取数量"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetWithdrawForm();withdrawVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmWithdraw()">确定</el-button>
      </el-row>
    </el-dialog>

    <el-dialog title="库存同步" top="20px" width="500px" :visible.sync="dialogVisibleBatch"> 
      <el-form :model="formBatch" ref="formBatch" label-width="auto">
        <el-form-item label="上传文件：" required="">
          <el-upload
            class="upload-demo"
             action="" :http-request="importExcel" :show-file-list="false">
            <el-button v-if="!formBatch.file" size="small" type="primary">点击上传</el-button>
            <span v-if="formBatch.file">{{ formBatch.file.name }}</span>
            <el-button v-if="formBatch.file" size="small" type="primary" style="margin-left: 5px;">重新上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="font-size: 12px;padding-left: 80px;color: #4200ff;cursor: pointer;" @click="exportExcel">下载模板</div>
      <el-row class="text-right mt-20">
        <el-button @click="formBatch.file='';dialogVisibleBatch=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmBatch()">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
 
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    //ComponentName和文件名保持一致
    name:'gameTaskPrizes',
    data() {
      //这里存放数据
      return {
        params: {
          pageNum: 1,
          pageSize: 10,
          prizeName: '',
          prizeTemplateId: ''
        },
        tableData: [],
        total: 0,
        buttonLoading: false, //按钮加载状态，默认为false不显示
        dialogVisible: false, //弹窗显示隐藏状态，默认为false不显示
        title: '新增', //弹窗标题
        form: {
          prizeId: null,
          productId: '',
          prizeTemplateId: '',
          stockWarn: '',
          warnMobile: ''
        }, //表单数据对象
        rules: {
          productId: [{ required: true, message: "请选择商品", trigger: "blur" }],
          prizeTemplateId: [{ required: true, message: "请输入券模板ID", trigger: "blur" }]
        },
        productList: [],
        warning:{
          title:'库存预警',
          visible:false,
        },
        warningRules: {
          stockWarn: [{ required: true, message: "请输入预警门槛", trigger: "blur" }],
          warnMobile: [{ required: true, message: "请输入预警手机号", trigger: "blur" }]
        },
        warningProductName: '',
        inventoryNum:'',
        visibleInventory: false,
        inventoryParams: {
          pageNum: 1,
          pageSize: 10,
          prizeId: '',
          isPage: true
        },
        inventoryData: [],
        inventoryTotal: 0,
        withdrawVisible: false,
        withdrawForm: {
          prizeId:'',
          extractNum:''
        },
        withdrawRules:{
          extractNum:[{ required: true, message: "请输入提取数量", trigger: "blur" }]
        },
        dialogVisibleBatch: false,
        formBatch: {
          file:{},
          prizeId: '',
          productId: ''
        },
        rowData:{}
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      getTableList(){
        this.ajax.fetch({
          url: this.apis.gameTaskPrizes.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      importExcel(file) {
        let index1 = file.file.name.lastIndexOf(".");
        let index2 = file.file.name.length;
        let postf = file.file.name.substring(index1, index2);//后缀名
        if (postf.indexOf('xlsx') === -1 && postf.indexOf('xls') === -1) {
          this.toast.showWarning('只能上传excel文件');
          return;
        }
        this.formBatch.file = file.file;
      },
      confirmBatch(){
        if(!this.formBatch.file) return this.$message.error('请选择文件');
        this.formBatch.prizeId = this.rowData.prizeId;
        this.formBatch.productId = this.rowData.productId;
        this.ajax.upload({
          url: this.apis.gameTaskPrizes.import,
          param: this.formBatch,
          successFunc: res => {
            this.$message.success('同步成功');
            this.dialogVisibleBatch = false;
            this.formBatch.file = '';
            this.getTableList();
          },
          errorFunc: res => {
            this.$message.error(res.info);
          }
        })
      },
      exportExcel(){
        this.ajax.downLoad(this.apis.netBarAccountManage.downLoad , {templateName:'cdKey'});
      },
      confirmWithdraw(){
        this.withdrawForm.prizeId = this.inventoryParams.prizeId;
        this.$refs.withdrawForm.validate(valid => {
          if (valid) {
            this.ajax.fetch({
              url: this.apis.gameTaskPrizes.extractCdKey,
              disableLoading: true,
              method: 'post',
              param: this.withdrawForm,
              successFunc: res=>{
                this.$message.success('提取成功!');
                this.withdrawVisible = false;
                this.resetWithdrawForm();
                this.tableData();
              },
              errorFunc: err=>{
                this.$message.error(err.info);
              }
            });
          } else {
            return false;
          }
        });
      },
      resetWithdrawForm(){
        this.withdrawForm = {
          prizeId:'',
          extractNum:''
        };
      },
      openInventory(row){
        this.rowData = row;
        this.inventoryNum = row.prizeStock;
        this.warningProductName = row.prizeName;
        this.inventoryParams.prizeId = row.prizeId;
        this.inventoryParams.pageNum = 1;
        this.inventoryParams.pageSize = 5;
        this.getSyncStockCdKeyList();
      },
      getSyncStockCdKeyList(){
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.getSyncStockCdKeyList,
          disableLoading: true,
          method: 'post',
          param: this.inventoryParams,
          successFunc: res=>{
            this.inventoryTotal = res.total;
            this.inventoryData = res.result;
            this.visibleInventory = true;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      openWarning(row){
        this.warning.title = '库存预警';
        this.warning.visible = true;
        this.form.prizeId = row.prizeId;
        this.form.productId = row.productId;
        this.warningProductName = row.prizeName;
      },
      confirmWarning(){
        this.$refs.warningForm.validate(valid => {
          if (valid) {
            this.ajax.fetch({
              url: this.apis.gameTaskPrizes.stockWarn,
              disableLoading: true,
              method: 'post',
              param: this.warningForm,
              successFunc: res=>{
                this.$message.success('预警成功!');
                this.warning.visible = false;
                this.getTableList();
              },
              errorFunc: err=>{
                this.$message.error(err.info);
              }
            });
          } else {
            return false;
          }
        });
      },
      update(row){
        this.title = '编辑';
        this.form.prizeId = row.prizeId;
        this.form.productId = row.productId;
        this.form.prizeTemplateId = row.prizeTemplateId;
        this.dialogVisible = true;
      },
      confirm(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.prizeId == null) {
              this.ajax.fetch({
                url: this.apis.gameTaskPrizes.add,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('新增成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }else{
              this.ajax.fetch({
                url: this.apis.gameTaskPrizes.update,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('编辑成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }
          }
        });
      },
      resetForm(){
        this.form = {
          prizeId: null,
          productId: '',
          prizeTemplateId: '',
          stockWarn: '',
          warnMobile: ''
        };
      },
      resetParams(){
        this.params = {
          pageNum: 1,
          pageSize: 10,
          prizeName: '',
          prizeTemplateId: ''
        }
      },
       getProductList(){
         this.ajax.fetch({
           url: this.apis.goodsManage.get,
           disableLoading: true,
           method: 'post',
           param: {
             productName: '',
             productType: '',
             pageNum: 1,
             pageSize: 999
           },
           successFunc: res=>{
             this.productList = res.result;
           },
           errorFunc: err=>{
             this.$message.error(err.info);
           }
         });
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
      handleSizeChangeInventory(page) {
        this.inventoryParams.pageSize = page;
        this.getSyncStockCdKeyList();
      },
      handleCurrentChangeInventory(val){
        this.inventoryParams.pageNum = val;
        this.getSyncStockCdKeyList();
      },
    },
    beforeCreate() {}, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    beforeMount() {}, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
    },
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/activityManage/gameTaskPrizes/gameTaskPrizes.vue